import './IndividualVersionHeader.css';

const IndividualVersionHeader = ({ language }) => {
  return (
    <h3 className="languageHeader">{language}</h3>
  );
};

export default IndividualVersionHeader;